import debugFactory from 'debug';

const debug = debugFactory('ingrid:bootstrap');

export function createIframe(src: string): HTMLIFrameElement {
  const iframe = document.createElement('iframe');
  iframe.src = src;

  iframe.onload = () => {
    debug(`Iframe loaded with src "${src}"`);
  };

  iframe.scrolling = 'no';
  iframe.style.border = 'unset';
  iframe.style.width = '100%';
  iframe.style.height = '100%';

  return iframe;
}

export type ContainerSelector = string | Node;

export function findContainer(selector: ContainerSelector): Node {
  if (selector instanceof Node) {
    // element was passed, nothing to select.
    return selector;
  }

  const container = document.getElementById(selector);
  if (container) {
    return container;
  }

  throw `The container with id "${selector}" was not found!`;
}

export function getContentWindow(iframe: HTMLIFrameElement): Window {
  if (iframe.contentWindow === null) {
    throw 'Iframe has no window. Check if the iframe has been injected into the DOM.';
  }

  return iframe.contentWindow;
}
